import translation from './locales/ru/translation.json';
import account from './locales/ru/account.json';
import translationEn from './locales/en/translation.json';
import accountEn from './locales/en/account.json';
import users from './locales/ru/users.json';
import usersEn from './locales/en/users.json';
import saml from './locales/ru/saml.json';
import samlEn from './locales/en/saml.json';
import oidc from './locales/ru/oidc.json';
import oidcEn from './locales/en/oidc.json';
export const defaultLocale = 'en';
export const defaultNS = 'translation';
export const resources = {
  ru: {
    translation,
    account,
    users,
    saml,
    oidc
  },
  en: {
    translation: translationEn,
    account: accountEn,
    users: usersEn,
    saml: samlEn,
    oidc: oidcEn
  }
} as const;
export const LOCALE_NAMESPACES = Object.keys(resources.ru);
export const APP_LANGS = Object.keys(resources);